<template>
  <a-tabs class="customer-tabbed-select-component" default-active-key="family" :tab-bar-style="{height:40}"
          size="small" style="overflow: visible">
    <a-tab-pane key="family" tab="Familie">
      <CustomerSelectFamilyMemberComponent ref="customerSelectFamilyMember"
                                           :customer-id="customerId"
                                           :value="value"
                                           v-on:customer-selected="onCustomerSelected"></CustomerSelectFamilyMemberComponent>
    </a-tab-pane>
    <a-tab-pane key="all" tab="Alle klanten">
      <DetailedCustomerSelectComponent @input="onCustomerSelected"/>
    </a-tab-pane>
  </a-tabs>
</template>

<script>
import CustomerSelectFamilyMemberComponent from "../../customer/components/SelectFamilyMemberComponent";
import DetailedCustomerSelectComponent from "~/pages/components/customer/DetailedCustomerSelectComponent.vue";

export default {
  name: "CustomerTabbedSelectComponent",
  components: {
    CustomerSelectFamilyMemberComponent,
    DetailedCustomerSelectComponent,
  },
  props: {
    customerId: {
      type: [String, Number],
      required: true
    },
    value: {
      type: Object,
      default: null,
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    onCustomerSelected(customer) {
      this.$emit('customer-selected', customer);
    },
  }
}
</script>
<style scoped>

</style>